import Vue3Toastify from "vue3-toastify";

export default defineNuxtPlugin((nuxtApp) => {
  const isDarkMode = localStorage.getItem("DarkMode") === "true";
  nuxtApp.vueApp.use(Vue3Toastify, {
    position: "bottom-right",
    theme: isDarkMode ? "dark" : "light",
  });
});
